import { InjectionToken } from '@angular/core';

export interface AppLoad {
  load(): void;
}

export const APP_LOAD = new InjectionToken<AppLoad>('APP_LOAD');
